<script lang="ts" setup>
import type {
  Component,
  FocalPointAsset,
  FromResolver,
} from "#magnolia-layer/types/magnolia-types";
import type {AspectRatio} from "#base-layer/utils/parseAspectRatio";

const {
  metadata,
  image,
  aspectRatio = "original",
} = defineProps<{
  metadata?: Component;
  image: FromResolver<FocalPointAsset>;
  aspectRatio: "original" | AspectRatio;
}>();

const assumeAboveFold = (metadata?.["@index"] ?? 0) < 1;
const loading = assumeAboveFold ? "eager" : "lazy";

const parsedRatio =
  aspectRatio === "original" ? undefined : parseAspectRatio(aspectRatio);
const extract =
  parsedRatio === undefined
    ? undefined
    : imageToExtractionArea(image, parsedRatio);
</script>

<template>
  <div class="image col-breakout ml-auto article-margin">
    <MagnoliaPicture
      :asset="image"
      :loading="loading"
      :modifiers="{
        extract,
        grayscale: 1,
      }"
      format="avif,webp"
      :quality="100"
      class=""
      densities="1x 2x"></MagnoliaPicture>
  </div>
</template>

<style lang="scss" scoped></style>
